export const MENU_ENDPOINT = {
  MENU: 'Menu',
};

export const MENU_QUERY_KEY = {
  MENU: 'Menu',
};
